<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen persistent >
            <v-toolbar dense flat scroll-off-screen color="white" class="fixed-top">
                <v-btn icon small flat @click="$emit('hide')">
                    <!--v-if="route" :to="route"-->
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title class="subheading">Shipping Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <slot></slot>
            </v-toolbar>
            <!--<v-card flat style="background: #80CBC4;" class="pa-3">-->
                <!--<div class="head">-->
                    <!--<div class="head__icon">-->
                        <!--<v-icon style="color: #f4f4f4;">mdi-truck</v-icon>-->
                    <!--</div>-->
                    <!--<div class="head__content">-->
                        <!--<div class="body-2 head__content-title">-->
                            <!--Quad X courier-->
                        <!--</div>-->
                        <!--<div class="body-1 head__content-subtitle">-->
                            <!--Tracking Number: {{trackingNumber}}-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</v-card>-->
            <v-card class="" flat>
                <div class="pa-3 subheading">
                    Logistics Tracking
                </div>
                <v-divider></v-divider>
                <v-card-title primary-title>
                    <v-timeline v-if="timeline.length"
                            align-top
                            dense
                    >
                        <v-timeline-item
                                v-for="(data,index) in timeline"
                                :color="(index == 0 ? 'teal lighten-3' : 'pink')"
                                small
                        >
                            <v-layout class="pb-3">
                                <v-flex>
                                    <strong>{{data.remarks}}</strong>
                                    <div class="caption">{{data.status_updated_at}}</div>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                        </v-timeline-item>
                    </v-timeline>
                    <div v-else >
                        <p style="color: red;">No Logistic Record Found</p>
                    </div>
                </v-card-title>
            </v-card>
        </v-dialog>
        <loader v-if="loading"></loader>
    </v-layout>
</template>

<script>
    import Loader from "../../components/Loader";
    export default {
        name: "PurchaseTracking",
        components: {Loader},
        props:{
            dialog : false,
            trackingNumber : {
                type : String,
                default : ''
            }
        },
        watch : {
            dialog : {
                handler(newValue){
                    if (this.dialog){
                        this.getLogisticReport();
                    }
                },
            }
        },
        data() {
             return{
                timeline : [],
                 loading : false,
             }
        },
        methods:{
            getLogisticReport(){
                this.loading = true;
                axios.get(`/api/logistic/${this.trackingNumber}`)
                    .then(res=>{
                        this.timeline = res.data.data;
                        this.loading = false;
                    })
                    .catch(err=>{
                        this.toaster('soemthing went wrong.', 201);
                    });
            }
        },

    }
</script>

<style lang="scss" scoped>
    .v-timeline.v-timeline--align-top.v-timeline--dense.theme--light{
        width: 100%;
    }
    .head{
        display: flex;

        &__icon{
            color: #f4f4f4;
        }

       &__content {
           color: #f4f4f4;
           margin-left: 20px;
       }
    }
    .fixed-top{


    }
</style>